import withApollo from 'next-with-apollo';
import ApolloClient, { InMemoryCache } from 'apollo-boost';
import { getGraphQLUrl } from '../urls';

const GRAPHQL_ENDPOINT = getGraphQLUrl();

function makeApolloClient({ initialState }) {
  return new ApolloClient({
    uri: GRAPHQL_ENDPOINT,
    cache: new InMemoryCache().restore(initialState || {}),
  });
}

// https://www.apollographql.com/docs/react/performance/server-side-rendering/#using-getdatafromtree
export default withApollo(makeApolloClient, { getDataFromTree: 'ssr' });
